import { useFormik } from 'formik';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '../../../../component/colors';
import { ImagePicker } from '../../../../component/imagePicker';
import { Input } from '../../../../component/input';
import { AddModal } from '../../../../component/modal';
import { useAddLifeStyleServiceMutation } from '../../../../store/lifeStyle/api';
import { showErrorToast, showSuccessToast } from '../../../../utils/toast';
import { addServiceValidation } from '../../validation';

type IAddCategory = {
  show?: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
};
type FormikValues = {
  title: string;
  file: File[] | null;
};
export const AddService: FC<IAddCategory> = ({ setShow }) => {
  const { state } = useLocation();
  const [categoryId] = useState((state as { categoryId: string }).categoryId);
  const [addLifestyleService, { isLoading: isServiceAdding }] =
    useAddLifeStyleServiceMutation();
  const handleFilePicked = (file: File[]) => {
    setFieldValue('file', file);
  };
  const handleAddCategory = (values: FormikValues) => {
    if (!values.file) return showErrorToast('service picture is required');
    const payload = new FormData();
    payload.append('title', values.title);
    payload.append('category', categoryId);
    values.file.forEach((file) => {
      payload.append('file', file);
    });
    addLifestyleService(payload)
      .unwrap()
      .then((res) => {
        showSuccessToast(res.message);
        setShow(false);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };
  const { values, errors, touched, setFieldValue, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        title: '',
        file: null
      },
      validationSchema: addServiceValidation,
      onSubmit: handleAddCategory
    });

  return (
    <AddModal
      title={`Add Service`}
      disableBtn={isServiceAdding}
      btnTxt={isServiceAdding ? 'Loading...' : 'Add Service'}
      btnClick={handleSubmit}
      closeModal={() => setShow(false)}
      isLoading={isServiceAdding}
    >
      <Container>
        <CustomInput
          labelText={'Service title'}
          value={values.title}
          onChange={handleChange('title')}
          errorMessage={touched.title ? errors.title : ''}
        />

        <CustomImageUpload onFilePicked={handleFilePicked} />
      </Container>
    </AddModal>
  );
};

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0px 40px;
  padding-bottom: 32px;
`;

const CustomInput = styled(Input)`
  flex: 0.46;
  color: ${colors.textDark};
  margin-bottom: 16px;
`;
const CustomImageUpload = styled(ImagePicker)``;
